import { constant } from "./../data/config";
import { COMMS_HANDLER } from "./commsHandler";

export const spinResponseService = {
    sendSpinResponse
};

async function sendSpinResponse(): Promise<any> {
    var d = new Date();
    var n = d.getTime();

    const gameInfo = (window as any).GAME_INFO;

    const params = {
        mode: "spin",
        gameID: gameInfo.gameID,
        accountID: gameInfo.accountID,
        stake: Number(gameInfo.stake),
        username: gameInfo.username,
        customerID: gameInfo.customerID,
        fun_real: gameInfo.playMode,
        ex_rate: gameInfo.ex_rate,
        currency: gameInfo.currency,
        site: gameInfo.site,
        jurisdiction: gameInfo.jurisdiction,
        now: n,
        gameType: gameInfo.gameType,
        version: gameInfo.version,
        isPromoRound: 0,
        promoActivationID: 0,
        promoCampaignID: 0,
        promoType: 0,
        buyIn: constant.configGame.buyInFeature_local,
        selection_0: constant.configGame.selection_local,
        buyInValue: constant.configGame.buyInValue_local
    };

    const data = await COMMS_HANDLER.makeRequest({ data: params });

    return { data };
}
